import { IDatePickerStrings } from '@fluentui/react';

export const DayPickerStrings: IDatePickerStrings = {
    months: [
        'Gennaio',
        'Febbraio',
        'Marzo',
        'Aprile',
        'Maggio',
        'Giugno',
        'Luglio',
        'Agosto',
        'Settembre',
        'Ottobre',
        'Novembre',
        'Dicembre',
    ],

    shortMonths: ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'],

    days: ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'],

    shortDays: ['D', 'L', 'M', 'M', 'G', 'V', 'S'],

    goToToday: 'Oggi',
    prevMonthAriaLabel: 'Mese precedente',
    nextMonthAriaLabel: 'Mese successivo',
    prevYearAriaLabel: 'Anno precedente',
    nextYearAriaLabel: 'Anno successivo',
    closeButtonAriaLabel: 'Chiudi',
    monthPickerHeaderAriaLabel: '{0}, click per cambiare anno',
    yearPickerHeaderAriaLabel: '{0}, click per cambiare mese',
};

